const accordion = (() => {
  const defaultAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        accordionContent.classList.toggle('js-active');
      });
    }
  };

  
  const customizeSelectAccordion = () => {
    document.addEventListener('DOMContentLoaded', function() {
      var selected = document.querySelector('.select-selected');
      var selectedValue = document.querySelector('.selected-select');
      var items = document.querySelector('.select-items');
      var searchInput = document.querySelector('.select-search input');
      
      if(selected){
        selected.addEventListener('click', function() {
          items.style.display = items.style.display === 'block' ? 'none' : 'block';
        });
    
        if(searchInput) {
          searchInput.addEventListener('input', function(e) {
            const searchText = e.target.value.toLowerCase();
            const options = items.querySelectorAll('div:not(.select-search)');
            
            options.forEach(function(option) {
              const text = option.textContent.toLowerCase();
              if(text.includes(searchText)) {
                option.style.display = '';
              } else {
                option.style.display = 'none';
              }
            });
          });
        }

        items.addEventListener('click', function(e) {
          const clickedItem = e.target;
          if (!clickedItem.closest('.select-search') && clickedItem.tagName === 'DIV') {
            selectedValue.textContent = clickedItem.textContent;
            selectedValue.setAttribute('data-value', clickedItem.getAttribute('data-value'));
            items.style.display = 'none';
          }
        });

        document.addEventListener('click', function(e) {
          if (!e.target.closest('.custom-select')) {
            items.style.display = 'none';
          }
        });
      }
    });
  };

  const init = () => {
    defaultAccordion();
    customizeSelectAccordion();
  };

  return {
    init,
  };
})();

export default accordion;
